<template lang="pug">
  #app(:class="{'is-mobile': isMobile}")
    app-header
    router-view.view
    app-footer
</template>

<script>
import AppHeader from './components/app-header.vue'
import AppFooter from './components/app-footer.vue'

export default {
  name: 'app',
  components: {
    AppHeader,
    AppFooter,
  },
  data () {
    return {
    }
  },
}
</script>

<style lang="stylus">
@import "base/base"

</style>



// WEBPACK FOOTER //
// src/App.vue